export default "__VITE_ASSET__BWl$ULFJ__"